/**This component is visible on the Updates section of the registered user fundraiser page */

import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { FundraiserService } from '../../../services/fundraiser.service';
import { MediaService } from '../../../services/media.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TranslateUpdatesComponent } from '../../dialogs/updates/translate-updates/translate-updates.component';
import { EditUpdateComponent } from '../../dialogs/updates/edit-update/edit-update.component';
import { CreateUpdateComponent } from '../../dialogs/updates/create-update/create-update.component';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { ShareUpdateComponent } from '../../dialogs/updates/share-update/share-update.component';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgImageSliderModule } from 'ng-image-slider';
import { QuillViewComponent } from '../../../../../shared/components/quill-view/quill-view.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { DeletePopupComponent } from '../../dialogs/delete-popup/delete-popup.component';
import { ImageSliderDialogComponent } from '../../dialogs/image-slider-dialog/image-slider-dialog.component';

@Component({
	selector: 'app-fundraiser-update-edit',
	templateUrl: './fundraiser-update-edit.component.html',
	standalone: true,
	imports: [
		NgIf,
		FlexModule,
		MatButtonModule,
		MatDividerModule,
		NgClass,
		ExtendedModule,
		NgFor,
		MatFormFieldModule,
		MatTooltipModule,
		QuillViewComponent,
		NgImageSliderModule,
		MatIconModule,
		MatProgressSpinnerModule,
		PageLoaderComponent,
		ImageSliderDialogComponent,
	],
})
export class FundraiserUpdateEditComponent implements OnInit, OnChanges {
	updatesList: any;
	locale!: string;
	updatesListLongPreview: any;
	@Input() fundraiserUpdates!: any;
	@Input() slug!: string;
	@Input() currentFundraiser!: any;
	@Input() fundraiserLocalId!: number;
	@Input() count: any;
	@Input() totalPages: any;
	@Output() refreshComponentEvent: EventEmitter<void> =
		new EventEmitter<void>();

	page: number = 1;
	loading: boolean = false;
	shareTooltip = $localize`:@@fund_mat_tooltip_share_icon: Share`;
	editTooltip = $localize`:@@fund_mat_tooltip_edit_icon: Edit`;
	translateTooltip = $localize`:@@fund_mat_tooltip_translate_icon: Translate`;
	deleteTooltip = $localize`:@@fund_mat_tooltip_delete_icon: Delete`;

	constructor(
		private notificationService: NotificationService,
		private _mediaService: MediaService,
		private _fundraiserService: FundraiserService,
		public accountService: AccountService,
		private _domSanitizer: DomSanitizer,
		public dialog: MatDialog,
		public _accountService: AccountService
	) {
		this.locale = this.accountService.getLocaleId();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.fundraiserUpdates) {
			let locale = this.accountService.getLocaleId();
			this.updatesList = this._fundraiserService.getUpdatesEditObj(
				this.fundraiserUpdates,
				locale
			);
			this.page = +this.fundraiserUpdates?.currentPage;
		}
	}

	ngOnInit(): void {}

	shareUpdate(index: number) {
		const dialogRef = this.dialog.open(ShareUpdateComponent, {
			maxHeight: '98vh',
			data: {
				update: this.updatesList[index],
				slug: this.currentFundraiser?.slug,
				currentFundraiser: this.currentFundraiser,
				shared: this.updatesList[index]?.shared,
			},
		});

		dialogRef.afterClosed().subscribe(() => {
			this.refreshComponent();
		});
	}

	santizeURL(url: any) {
		return this._domSanitizer.bypassSecurityTrustResourceUrl(url);
	}

	getVideoEmbeddedHTML(url: any) {
		return this._mediaService.createVideoEmbeddedHTML(url);
	}

	refreshComponent() {
		this.refreshComponentEvent.emit();
	}

	viewMore() {
		this.loading = true;
		this._fundraiserService
			.getUpdates(this.slug, this._accountService.getLocaleId(), this.page + 1)
			.subscribe((updatesData: any) => {
				const newUpdates = this._fundraiserService.getUpdatesViewObj(
					updatesData['data'],
					this._accountService.getLocaleId()
				);

				// Append the newUpdates to the existing updatesList
				this.updatesList = this.updatesList.concat(newUpdates);

				// Increment the page number for the next load
				this.page += 1;
				this.loading = false;
			});
	}

	editUpdate(index: number) {
		const pageToFetch = Math.floor(index / 3) + 1;

		if (this.updatesListLongPreview?.[index]) {
			this.openEditDialog(this.updatesListLongPreview[index]);
			return;
		}

		this._fundraiserService
			.getUpdatesForAdmin(this.slug, this.locale, pageToFetch)
			.subscribe((updatesData: any) => {
				const newUpdates = this._fundraiserService.getUpdatesEditObj(
					updatesData['data'],
					this.locale
				);

				if (!this.updatesListLongPreview) {
					this.updatesListLongPreview = [];
				}

				const startIndex = (pageToFetch - 1) * 3;

				for (let i = 0; i < newUpdates.length; i++) {
					this.updatesListLongPreview[startIndex + i] = newUpdates[i];
				}

				this.openEditDialog(this.updatesListLongPreview[index]);
			});
	}

	openEditDialog(update: any) {
		const dialogRef = this.dialog.open(EditUpdateComponent, {
			maxHeight: '98vh',
			data: {
				update: update,
				fundraiserLocalId: this.fundraiserLocalId,
				slug: this.slug,
			},
		});
	}

	translateUpdate(index: number) {
		const dialogRef = this.dialog.open(TranslateUpdatesComponent, {
			maxHeight: '98vh',
			data: {
				update: this.updatesList[index],
				slug: this.currentFundraiser?.slug,
				locale: this.currentFundraiser?.language_code,
			},
		});
	}
	createUpdate() {
		const dialogRef = this.dialog.open(CreateUpdateComponent, {
			maxHeight: '98vh',
			data: {
				update: {
					id: null,
					date: null,
					content: ' ',
					mediaList: [],
				},
				fundraiserLocalId: this.fundraiserLocalId,
				slug: this.slug,
				originalLocale: this.currentFundraiser?.language_code,
			},
		});

		dialogRef.afterClosed().subscribe((isUpdateCreated) => {
			if (isUpdateCreated) {
				// Below code will start loader
				this.updatesList = undefined;
				// Get updates of fundraising
				let locale = this.accountService.getLocaleId();
				this._fundraiserService
					.getUpdates(this.slug, locale, 1)
					.subscribe((updatesData: any) => {
						this.updatesList = this._fundraiserService.getUpdatesEditObj(
							updatesData['data'],
							locale
						);
						this.shareUpdate(0);
					});
			}
		});
	}

	deleteUpdate(index: number) {
		const dialogRef = this.dialog.open(DeletePopupComponent, {
			width: '400px',
			disableClose: true,
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				const update = this.updatesList[index];
				if (!update?.id) {
					this.notificationService.openNotification(
						$localize`:@@fundraiser_update_edit_error_notification:There was an error while deleting Fundraiser Update`,
						'OK',
						'error'
					);
				} else {
					this._fundraiserService.deleteUpdates(update.id).subscribe(
						(res: any) => {
							this.updatesList.splice(index, 1);
							this.notificationService.openNotification(
								$localize`:@@fundraiser_update_edit_fundraiserUpdateDeleted_notification:Fundraiser Update is deleted`,
								'OK',
								'success'
							);
							this.refreshComponent();
						},
						(err: any) => {
							this.notificationService.openNotification(
								$localize`:@@fundraiser_update_edit_error_notification:There was an error while deleting Fundraiser Update`,
								'OK',
								'error'
							);
						}
					);
				}
			}
		});
	}

	hoverListItem(updates: any) {
		updates.listItemHovered = !updates.listItemHovered;
	}

	openCustomDialog(clickedImage: any, imageList: any): void {
		this.dialog.open(ImageSliderDialogComponent, {
			data: {
				images: imageList,
				clickedImage,
			},
			maxWidth: '95vw',
			width: '100%',
		});
	}
}
